var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "progress my-3" }, [
      _c(
        "div",
        {
          staticClass: "progress-bar",
          style: "width:" + _vm.progressPercen + "%",
          attrs: {
            role: "progressbar",
            "aria-valuenow": "25",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        },
        [_vm._v(_vm._s(_vm.progressPercen) + "%")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-around" }, [
      _vm.useButton && 13 > _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              on: { click: _vm.nextPage }
            },
            [_vm._v("\n            ถัดไป\n        ")]
          )
        : _vm._e(),
      _vm._v(" "),
      1 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              on: {
                click: function($event) {
                  return _vm.initFormNimcap()
                }
              }
            },
            [_vm._v("สมัคร")]
          )
        : _vm._e(),
      _vm._v(" "),
      2 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              attrs: { disabled: !_vm.borrowerConfirmBtn },
              on: {
                click: function($event) {
                  return _vm.saveConfirmPDPA()
                }
              }
            },
            [_vm._v("ยินยอม")]
          )
        : _vm._e(),
      _vm._v(" "),
      3 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              on: { click: _vm.nextPage }
            },
            [_vm._v("เริ่มต้น")]
          )
        : _vm._e(),
      _vm._v(" "),
      4 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              attrs: { disabled: !_vm.imageIdCardConfirmBtn },
              on: {
                click: function($event) {
                  return _vm.saveImageIDCard()
                }
              }
            },
            [_vm._v("ถัดไป")]
          )
        : _vm._e(),
      _vm._v(" "),
      5 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              attrs: { disabled: !_vm.faceWithIdCardImageConfirmBtn },
              on: {
                click: function($event) {
                  return _vm.saveFaceWithIdCardImage()
                }
              }
            },
            [_vm._v("ถัดไป")]
          )
        : _vm._e(),
      _vm._v(" "),
      6 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              attrs: { disabled: !_vm.signatureConfirmBtn },
              on: {
                click: function($event) {
                  return _vm.saveSignature()
                }
              }
            },
            [_vm._v("ยืนยัน")]
          )
        : _vm._e(),
      _vm._v(" "),
      7 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              attrs: { disabled: !_vm.guarantorConfirmBtn },
              on: {
                click: function($event) {
                  return _vm.saveGuarantorConfirmPDPA()
                }
              }
            },
            [_vm._v("ยินยอม")]
          )
        : _vm._e(),
      _vm._v(" "),
      8 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              attrs: { disabled: !_vm.guarantorImageIdCardConfirmBtn },
              on: {
                click: function($event) {
                  return _vm.saveGuarantorImageIDCard()
                }
              }
            },
            [_vm._v("ถัดไป")]
          )
        : _vm._e(),
      _vm._v(" "),
      9 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              attrs: { disabled: !_vm.guarantorFaceWithIdCardImageConfirmBtn },
              on: {
                click: function($event) {
                  return _vm.saveGuarantorFaceWithIdCardImage()
                }
              }
            },
            [_vm._v("ถัดไป")]
          )
        : _vm._e(),
      _vm._v(" "),
      10 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              attrs: { disabled: !_vm.guarantorSignatureConfirmBtn },
              on: {
                click: function($event) {
                  return _vm.saveSignatureConfirm()
                }
              }
            },
            [_vm._v("ยืนยัน")]
          )
        : _vm._e(),
      _vm._v(" "),
      11 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              on: { click: _vm.nextPage }
            },
            [_vm._v("ตรวจสอบรายละเอียดการกู้")]
          )
        : _vm._e(),
      _vm._v(" "),
      13 == _vm.page
        ? _c(
            "button",
            {
              staticClass: "btn btn-lg btn-info btn-block-cyan",
              on: { click: _vm.saveFormNimcap }
            },
            [_vm._v("บันทึก")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47e7e4f3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47e7e4f3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/ProgressStep.vue
// module id = 2314
// module chunks = 0